module.exports = __webpack_public_path__ + "media/images/shoppable-8f22919d29be2f7f0639351dc29ddd9b.png";